import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  gap: 8px;
  height: 52px;
  min-width: 100px;
  background-color: ${(props) => props.theme.colors.widget_background};

  .trip-status {
    position: relative;

    .start {
      width: 12px;
      height: 12px;
      background: ${(props) => props.theme.colors.main_cta};
      border-radius: 100px;
    }

    .middle {
      position: absolute;
      top: 12px;
      bottom: 12px;
      left: 5px;
      border: 1px solid ${(props) => props.theme.colors.text};
      width: 0px;
    }

    .end {
      position: absolute;
      bottom: 0;
      width: 12px;
      height: 12px;
      border: 2px solid ${(props) => props.theme.colors.text};
      border-radius: 100px;
    }
  }

  .description {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    white-space: nowrap;
    gap: 8px;
    text-overflow: ellipsis;

    .title {
      max-height: 22px;
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .subtitle {
      font-size: 16px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
`;

export default { Wrapper };
